import styled from 'styled-components';
import { rgba } from 'polished';
import { COLOR_RED } from '../../../../assets/styles/colors';
import { BP_MOBILE_MAX } from '../../../../assets/styles/breakpoints';

export default styled.div`
  .modal-loading-wrap {
    display: flex;
    justify-content: center;
  }
  .top-text-wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
    h2 {
      max-width: 100%;
    }
  }

  .bid-wrap {
    padding-top: 48px;
  }
  .checkbox-wrap {
    padding-top: 20px;
  }

  .submit-wrap {
    margin-top: 48px;
    button {
      width: 100%;
    }
  }

  @media (max-width: ${BP_MOBILE_MAX}px) {
    .price-wrap {
      padding-top: 24px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;

      h2 {
        font-size: 45px;
        line-height: 50px;
      }
    }
  }
`;

export const ErrorWrapSC = styled.div`
  margin-top: 24px;
  border-radius: 12px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: ${rgba(COLOR_RED, 0.1)};
  p {
    &:last-child {
      line-height: 1.25;
    }
  }
`;
